import ButtonUrl from 'components/Buttons/ButtonUrl';
import React, { useContext } from 'react';
import { I18nContext } from 'translations';

const MercadoFlexActivation = ({ url }) => {
  const { translate } = useContext(I18nContext);

  return (
    <ButtonUrl url={url} label={translate('app.integrations.table.activate')} />
  );
};

export default MercadoFlexActivation;
